export const Projects = [
  {
    name: "SuitePadSP",
    title: "SuitePad Status Page",
    subtitle: "Oct 2018 - Nov 2018",
    skills: [
      { id: "ux", name: "UX/UI" },
      { id: "web", name: "Web Design" }
    ],
    description:
      "The SuitePad Status Page was intended for use both internally and externally as a quick way for both devs and clients to see the status of SuitePad's network and, importantly, what services are affected. It serves as the first layer for analysis and provides quick links to a third party website for more in depth view of the problem. Currently in development."
  },
  {
    name: "MemoryMazeMobile",
    title: "Memory Maze Mobile App",
    subtitle: "May 2018 - Jul 2018",
    skills: [
      { id: "ux", name: "UX/UI" },
      { id: "mobile", name: "Mobile Design" }
    ],
    description:
      "Memory Maze Mobile App is the mobile version of Memory Maze flash card online app, with the extended feature of sharing and downloading lists from the online community. The focus of the design was to simplify each screen to just one main action to ensure the same smooth user flow as in the web version."
  },
  {
    name: "Priori",
    title: "Priori Data",
    subtitle: "Dec 2017 - Apr 2018",
    skills: [
      { id: "ux", name: "UX/UI" },
      { id: "web", name: "Web Design" },
      { id: "icon", name: "Iconography" }
    ],
    website: "https://prioridata.com/",
    description:
      "Priori Data is a web application that offers in depth extrapolated data on mobile apps. The data is based on the what is available public from Apple and Android, as well as data privately collected from apps themselves. Brought in as a freelance UX Designer I worked on selected usability issues including merging graphs and tables displaying different data into a coherent single dashboard, clearly displaying new features on an already information heavy layout, as well as giving UI redesign recommendations for the overall app."
  },
  {
    name: "MountainLife",
    title: "Mountain Life Poster",
    subtitle: "Mar 2018",
    skills: [
      { id: "graphic", name: "Graphic Design" },
      { id: "illustration", name: "Illustration" }
    ],
    attribution:
      "https://www.freepik.com/free-psd/frame-mockup-with-poster_772920.htm",
    description:
      "Mountain Life is a commission based poster series. The brief was to create a set of posters which depict an idyllic mountain scene in a modern flat illustration style. Primarily drawn in Adobe Illustrator."
  },
  {
    name: "MemoryMaze",
    title: "Memory Maze Web App",
    subtitle: "Jan 2018 - Apr 2018",
    skills: [{ id: "ux", name: "UX/UI" }, { id: "web", name: "Web Design" }],
    website: "https://alannahw.github.io/memorymaze/",
    description:
      "Memory Maze is an extended flash card web application which tracks the user’s progress and customises an ideal revision plan. It uses Ebbinghaus’ forgetting curve to assume memory retention over time, coupled with game scores it calculates an estimated curve and predicts the next revision date. The game is a variant of the Leitner system for learning flashcards, also known as spaced repetition. A demo version can be found here:"
  },
  {
    name: "Kronos",
    title: "Kronos Web App",
    subtitle: "Mar 2017 - Dec 2017",
    skills: [{ id: "ux", name: "UX/UI" }, { id: "web", name: "Web Design" }],
    description:
      "Kronos is a timesheet calculator and report maker. It takes a csv timesheet and formats it into a presentable series of tables and graphs depicting projects per date. A tool for freelancers it promotes increased transparency and improved communication with clients. Further features include quote planner and time tracker. The app is currently in planning phases with a Berlin based development team."
  },
  {
    name: "KronosBranding",
    title: "Kronos Branding",
    subtitle: "Mar 2017",
    skills: [
      { id: "branding", name: "Branding" },
      { id: "graphic", name: "Graphic Design" }
    ],
    description:
      "Branding was the initialising project for prospective company Kronos. The company is targeted at freelancers and provides a toolkit web application including features such as a time tracker, reporting, invoicing, and quote planner. The branding was designed to have minimal colours as a background application that works behind the scenes to support freelancers in the not-so-exciting organisational tasks."
  },
  // {
  //   name: "ErentoStatic",
  //   title: "Erento Static Sites",
  //   subtitle: "Oct 2015 - Jun 2016",
  //   skills: [
  //     { id: "ux", name: "UX/UI" },
  //     { id: "web", name: "Web Design" },
  //     { id: "icon", name: "Iconography" }
  //   ],
  //   description:
  //     "Erento is an online rental application offering products ranging from motorhomes to party equipment and everyday tools. A clean, easy user interface with colourful icons was designed for both the seller and customer sides of the application. Colour was used to highlight important links and notification leading the user through the intended UX flow."
  // },
  {
    name: "Erento",
    title: "Erento Web App",
    subtitle: "Dec 2014 - Jun 2016",
    skills: [
      { id: "ux", name: "UX/UI" },
      { id: "web", name: "Web Design" },
      { id: "icon", name: "Iconography" }
    ],
    description:
      "Erento is an online rental marketplace connecting rental companies of all types with customers all around the world. Products range from motorhomes and cars to construction equipment to event spaces and everyday tools. Working as the in-house graphic and UX designer I worked from scratch on a complete overhaul of the web application. The aim was for a clean, modern user interface with a friendly inviting image. A lightweight feel was achieved with plenty of whitespace, thin delineating borders and colourful highlights."
  },
  {
    name: "ErentoBranding",
    title: "Erento Branding",
    subtitle: "Jun 2014 - Dec 2014",
    skills: [
      { id: "branding", name: "Branding" },
      { id: "graphic", name: "Graphic Design" }
    ],
    description:
      "Erento’s expansion from the B2B market into B2C required an identity overhaul. I was hired as the in-house graphic and UX designer to rebrand Erento. Fun, fresh and user-friendly underpinned the aesthetic. An electric blue backed by navy were selected as the primary colours alluding to innovation and trust respectively, with orange and fuchsia as the highlights, adding fun and creativity to the mix. The logo was redesigned as a simple, scalable and easily recognisable form representing easy sharing online."
  },
  {
    name: "EndEcocide",
    title: "End Ecocide Posters",
    subtitle: "Jun 2013 - Dec 2013",
    skills: [
      { id: "graphic", name: "Graphic Design" },
      { id: "illustration", name: "Illustration" }
    ],
    description:
      "End Ecocide in Europe was a political youth initiative aiming to amend international law to include ecocide as a recognised crime. I supported the volunteer group with poster and flyer designs. The designs were decided to have a subtler friendlier look than traditional activist collateral, as something that might appeal to a broader audience."
  }
];



// WEBPACK FOOTER //
// ./src/ProjectsContent.js